// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:33:34

export default {
  "id": "planet-hopper",
  "slug": "planet-hopper",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/63d8caeaddca423e95fd7b181abbeb70-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/63d8caeaddca423e95fd7b181abbeb70/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Planet Hopper",
      "description": "Use your ship to navigate and jump between different planets across the galaxy, but be careful not to drift off into the vastness of outer space!",
      "instructions": "Click or tap to jump between planets.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "galaxy",
        "space",
        "spaceship"
      ]
    },
    "zh-CN": {
      "title": "星球跳跃者",
      "description": "使用你的飞船在银河系中穿梭，在不同行星间跳跃，但小心不要迷失在浩瀚的宇宙深处！",
      "instructions": "点击或轻触以在行星间跳跃。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "银河",
        "太空",
        "宇宙飞船"
      ]
    },
    "zh-TW": {
      "title": "星際跳躍者",
      "description": "使用你的船隻在銀河間穿梭並跳躍至不同的行星，但請小心不要漂離浩瀚的外太空！",
      "instructions": "點擊或滑動以跳轉至不同行星。",
      "genres": [
        "休闲"
      ],
      "tags": [
        "銀河",
        "宇宙",
        "太空船"
      ]
    },
    "zh-HK": {
      "title": "星際跳躍者",
      "description": "使用你的船艦在銀河中穿梭，穿梭於不同星球之間，但要注意不要迷失在浩瀚的宇宙空間裡！",
      "instructions": "點擊或觸控以跳轉至其他行星。",
      "genres": [
        "隨機"
      ],
      "tags": [
        "銀河",
        "太空",
        "宇宙船"
      ]
    },
    "ja": {
      "title": "プラネット・ホッパー",
      "description": "あなたの船を使って銀河の様々な惑星間を航行し、ジャンプするが、宇宙の広大さに迷い込まないように注意してください！",
      "instructions": "惑星間をジャンプするにはクリックまたはタップしてください。",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "銀河",
        "宇宙",
        "宇宙船"
      ]
    },
    "ko": {
      "title": "행성�opper",
      "description": "우주의 다양한 행성 간을 배를 타고 이동하고 점프하세요, 하지만 우주의 무한한 공간 속으로 빠지지 마세요!",
      "instructions": "행성 사이를 클릭하거나 탭하여 이동하세요.",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "galaxy:銀河\nspace: 우주\nspaceship: 우주선"
      ]
    },
    "fr": {
      "title": "Hoppéplanète",
      "description": "Utilisez votre navire pour naviguer et sauter entre différentes planètes à travers la galaxie, mais soyez prudent pour ne pas vous éloigner dans l'infini de l'espace lointain !",
      "instructions": "Cliquez ou tapez pour sauter d'une planète à l'autre.",
      "genres": [
        "Casual"
      ],
      "tags": [
        "galaxie",
        "espace",
        "vaisseau spatial"
      ]
    }
  }
};
